import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../components/pages/CustomPageHeader";
import MyPolls from "../components/MyPolls";
import RequestedPolls from "../components/RequestedPolls";

const Polls = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("my");
  const [votedPolls, setVotedPolls] = useState([]);
  
  const handleBack = () => {
    // Check if we came from Settings page
    const fromSettings = location.state?.from === 'settings' || 
                         document.referrer.includes('/settings');
    
    if (fromSettings) {
      navigate('/settings');
    } else {
      navigate('/home');
    }
  };

  return (
    <>
      <CustomPageHeader
        pageContainerClass=""
        pageContainerInnerClass="p-2 sm:p-0 md:p-0"
        title={t("polls", "Vibelinks")}
        onBack={handleBack}
      >
        <div className="flex justify-end">
          <button
            onClick={() => navigate("/create-poll")}
            className="text-[#6d29f6] font-semibold"
          >
            {t("create_poll")}
          </button>
        </div>

        {/* Tabs */}
        <div className="flex mt-4 border border-purple-500 rounded-lg p-1 overflow-hidden">
          <button
            onClick={() => setActiveTab("my")}
            className={`flex-1 py-2 font-semibold rounded-md ${
              activeTab === "my"
                ? "bg-[#6d29f6] text-white"
                : "bg-transparent text-gray-500"
            }`}
          >
            {t("my_polls_new")}
          </button>
          <button
            onClick={() => setActiveTab("requested")}
            className={`flex-1 py-2 font-semibold rounded-md ${
              activeTab === "requested"
                ? "bg-[#6d29f6] text-white"
                : "bg-transparent text-gray-500"
            }`}
          >
            {t("requested_polls")}
          </button>
        </div>

        {/* Tab Content */}
        <div className="mt-4">
          {activeTab === "my" && (
            <MyPolls
              key="my-polls"
              votedPolls={votedPolls}
              setVotedPolls={setVotedPolls}
              isActive={activeTab === "my"}
            />
          )}
          {activeTab === "requested" && (
            <RequestedPolls
              key="requested-polls"
              votedPolls={votedPolls}
              setVotedPolls={setVotedPolls}
              isActive={activeTab === "requested"}
            />
          )}
        </div>
      </CustomPageHeader>
    </>
  );
};

export default Polls;
